import { getAllData, createDocument } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { useCallback, useState } from "react";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import { Input, Button } from "styled";
import getFormattedDate from "utils/helpers";

const GrnRejectStatusLastFourMonthsFleetWise = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [downloading, setDownloading] = useState(false)
  const [check, setCheck] = useState(true)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const getData = async ()=>{
    setCheck(false)
    setIsLoading(true)
    const dt = await createDocument("/report/grnRejectStatusLastFourMonthsFleetWise", {
      ...(selectedFleets?.includes("all")
        ? {
          fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
          .map((item) => item.value)
              .join(","),
          }
        : selectedFleets.length && {
            fleets: selectedFleets.map((fleet) => fleet).join(","),
          }),
      ...(selectedHubs?.includes("all")
        ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
              .map((item) => item.value)
              .join(","),
          }
        : selectedHubs.length && {
            hubs: selectedHubs.map((hub) => hub).join(","),
          }),
      ...(dateFrom && { dateFrom }),
      ...(dateTo && { dateTo }),
    })
    // console.log(dt)
    setData(dt);
    setIsLoading(false)
  }

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  return (
    <div>
      <div className="w-full px-8 flex justify-center items-center gap-4">
      <label className="w-full py-3">
          Select Fleets
          <ReactSelect  
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 mb-2"
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find((item) => item?.value === fleet)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if(allValues?.includes("clear")){
                // console.log(allValues)
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if(!selectedFleets?.includes("all") && allValues.includes("all")){
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                // console.log("first");
                // console.log(getFleetOptions())
                value = value.filter(item => item.value!== "all")
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );
              
              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              // console.log({allHubs, selectedHubs})
              
              setSelectedFleets(value.map((fleet) => fleet.value));
              }
          }
            name="fleets"
            isMulti = {true}
          />
      </label>
      <label className="w-full py-3">
        Select Hubs
        <ReactSelect
          styles={{
            control: (base, state) => ({
              ...base,
              borderColor: "transparent",
              minWidth: "100%",
              "&:hover": {
                borderColor: "rgb(34 197 94)",
              },
            }),
          }}
          className="shadow-md rounded-md py-1 mb-2"
          options={getHubOptions()}
          value={
            selectedHubs &&
            selectedHubs?.map((hub) => {
              // console.log({hub})
              return {
                value: hub,
                label: getHubOptions()?.find((item) => item.value === hub)
                  ?.label,
              };
            })
          }
          onChange={(value) => {
            const allValues = value?.map((item) => item.value);
            // console.log({allValues})
            if(allValues.includes("clear")){
              setSelectedHubs([])
              return;
            }
            if (!selectedHubs?.includes("all") && allValues.includes("all")) {
              let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              )?.map(fleet=>fleet.fleetCode);

              const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

              const mp = fleetMap;
              selectedHubsData.map(hub=>{
                if(selectedFleetCodes?.includes(hub.fleetCode)){
                if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
              }})

              setFleetMap(mp);
              setSelectedHubs(["all"])
            } 
            else {
              // console.log({value})
              value = value.filter(value => value.value!== "all")
              // console.log({value})
              let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              )?.map(fleet=>fleet.fleetCode);
              // console.log({allValues})
            
              const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
              const mp = {};
              selectedHubsData.map(hub=>{
                mp[hub.fleetCode] = [];
              })

              selectedHubsData.map(hub=>{
                if(selectedFleetCodes?.includes(hub.fleetCode)){
                if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
              }})

              setFleetMap(mp);                  
              setSelectedHubs(value.map((hub) => hub.value));
            }
          }}
          name="hubs"
          isMulti={true}
        />
      </label>
      </div>
      <div className="w-full px-8 flex flex-start items-center gap-4">
      <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>

        <Button type="button" disabled= {selectedFleets.length == 0 || selectedHubs.length === 0} bgPrimary onClick={()=>getData()}>
            Search
          </Button>

      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        (data && data.data && data.data.region?.length > 0) ?
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                {data && data.data && data.data.regions?.length > 0 && (
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <TH scope="col">Fleet</TH>
                        <TH scope="col">Sum of Tyres Supplied</TH>
                        {data.data.regions.map((hub) => (
                          <TH scope="col">{hub.region}</TH>
                        ))}
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      <TD>{selectedFleets.label}</TD>
                      <TD>{data.data.total}</TD>
                      {data.data.regions?.map((region) => (
                        <TD>{region.totalRejected}</TD>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          </div>
        </div>:
        !check && selectedHubs?.length!==0 ? <div className= "text-center mt-5"> Data not found </div>: <></>
      )}
    </div>
  );
};

export default GrnRejectStatusLastFourMonthsFleetWise;
